/**
 * Flag indicating whether the resource timing api is supported or not.
 * http://caniuse.com/#feat=resource-timing
 */
const isPerformanceResourceSupported =
    typeof window !== typeof undefined &&
    window.hasOwnProperty('Performance') &&
    Performance.prototype.getEntriesByName;

export default isPerformanceResourceSupported;
